function toTrackingSegment(value: string) {
    return value
        .trim()
        .replace(/[^A-Za-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
}

export function getServiceOverviewAutoTrackingKey(baseTrackingKey: string, serviceName: string) {
    const trackingLabel = toTrackingSegment(serviceName);
    return trackingLabel ? `${baseTrackingKey}.${trackingLabel}` : baseTrackingKey;
}
